import {
  Code,
  Link,
  List,
  ListItem,
  Paragraph,
  Popover,
  PopoverContent,
  Strong,
  Text,
} from '@customerio/pluma-components/react';

type SearchTipProps = {
  example: string;
  children: string;
};

function SearchTip({ example, children }: SearchTipProps) {
  return (
    <ListItem>
      <Code weight="semibold">{example}</Code>
      <Paragraph variant="secondary">{children}</Paragraph>
    </ListItem>
  );
}

/** The "Need search tips?" popover explaining the email search wildcard syntax. */
export function EmailSearchPopover() {
  return (
    <Popover shouldTriggerOnClick={false} shouldTriggerOnFocus shouldTriggerOnHover>
      {(context) => (
        <>
          <Text>
            <Link icon="help" ref={context.reference.setReference} {...context.reference.getReferenceProps()}>
              Need search tips?
            </Link>
          </Text>
          <PopoverContent style={{ width: '350px' }}>
            <Paragraph>
              <Strong>You may use wildcards at the end of address or domain</Strong>. Here are some valid search terms:
            </Paragraph>
            <List styleType="none" gap="100" mt="150">
              <SearchTip example="ami@customer.io">Searches for that exact email</SearchTip>
              <SearchTip example="ami">
                Searches for any email that has the exact username 'ami', regardless of domain (ami@customer.io,
                ami@gmail.com)
              </SearchTip>
              <SearchTip example="ami*">
                Searches for any email that starts with 'ami' (ami@customer.io, ami+admin@customer.io.)
              </SearchTip>
              <SearchTip example="ami*@customer.io">
                Searches for any email starting with ami for the domain customer.io
              </SearchTip>
              <SearchTip example="@customer.io">Searches for any emails for the domain customer.io</SearchTip>
              <SearchTip example="@customer*">Searches for any emails for domains starting with customer</SearchTip>
            </List>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
}
